import { render } from "./Scroll.vue?vue&type=template&id=671c587a&scoped=true"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"

import "./Scroll.vue?vue&type=style&index=0&id=671c587a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671c587a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
